import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const ContractsModal = (props) => {
  const { open, setOpen, data } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const dataList = Object.entries(data)?.map(([date, sum]) => ({ date, sum }));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[55vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !mb-5 !bg-[#CDCDCDC7]'
      >
        <span className='mr-4'>{t('bossPage.debtsGraph.monthly')}</span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper'>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <div className='changes-table'>
                <TableContainer className='flex-auto w-full h-full !shadow-none !base-border'>
                  <Table
                    stickyHeader
                    sx={{ width: 'inherit' }}
                    aria-labelledby='tableTitle'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>№</TableCell>
                        <TableCell>{t('common.table.date')}</TableCell>
                        <TableCell>{t('common.table.sum')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className='overflow-hidden'>
                      {dataList.map((row, rowIndex) => (
                        <TableRow hover tabIndex={-1} key={'row-' + rowIndex}>
                          <TableCell>{rowIndex + 1}</TableCell>
                          <TableCell>
                            {moment(row?.date, 'YYYY-MM').format('YYYY MMMM')}
                          </TableCell>
                          <TableCell>
                            <CurrencyFormat value={row?.sum} suffix={' UZS'} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ContractsModal);
